export function downloadCSV(headers: string[], rows: string[][], filename: string) {
  const bom = '\uFEFF';
  const headerLine = headers.map(h => `"${h}"`).join(',');
  const dataLines = rows.map(row => row.map(cell => `"${cell.replace(/"/g, '""')}"`).join(','));
  const csv = bom + [headerLine, ...dataLines].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}